/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_CLIENT_DETAILS,
  GET_CLIENT_DETAILS_ERROR,
  REMOVE_CLIENT_DETAILS,
  REMOVE_CLIENT_DETAILS_ERROR,
  REMOVE_CLIENT_DETAILS_EMPTY,
  VERIFY_PAYMENT,
  VERIFY_PAYMENT_ERROR,
  SUBSCRIPTION_DETAILS,
  SUBSCRIPTION_DETAILS_ERROR,
  SUBSCRIPTION_DETAILS_EMPTY,
  CANCEL_SUBSCRIPTION_DETAILS,
  CANCEL_SUBSCRIPTION_DETAILS_ERROR,
  CANCEL_SUBSCRIPTION_DETAILS_EMPTY,
  CHANGE_PLAN_SUCCESS,
  CHANGE_PLAN_ERROR,
  CHANGE_PRIMARYCONTACT_SUCCESS,
  CHANGE_PRIMARYCONTACT_ERROR,
  CHANGE_PRIMARYCONTACT_EMPTY,
  CHANGE_PLAN_EMPTY,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_ERROR,
  CANCEL_SUBSCRIPTION_EMPTY,
  VERIFY_CANCEL_SUBSCRIPTION_SUCCESS,
  VERIFY_CANCEL_SUBSCRIPTION_ERROR,
  VERIFY_CANCEL_SUBSCRIPTION_EMPTY,
  LOADER,
  VERIFY_PAYMENT_EMPTY,
  CHANGE_PAYMENT_METHOD_SUCCESS,
  CHANGE_PAYMENT_METHOD_ERROR,
  CHANGE_PAYMENT_METHOD_EMPTY,
  RENEW_SUBSCRIPTION_SUCCESS,
  RENEW_SUBSCRIPTION_ERROR,
  RENEW_SUBSCRIPTION_EMPTY,
  REVERT_SUBSCRIPTION_SUCCESS,
  REVERT_SUBSCRIPTION_ERROR,
  REVERT_SUBSCRIPTION_EMPTY,
  VERIFY_RENEW_SUBSCRIPTION_SUCCESS,
  VERIFY_RENEW_SUBSCRIPTION_ERROR,
  VERIFY_RENEW_SUBSCRIPTION_EMPTY,
  REVERT_ONLY_SUCCESS,
  REVERT_ONLY_ERROR,
  REVERT_ONLY_EMPTY
} from 'src/actions/subscriptionActions';

const initialState = {
  clientDetails: null,
  clientDetailsError: null,
  removeClientDetails: null,
  removeClientDetailsError: null,
  verifyPaymentSuccess: null,
  verifyPaymentError: null,
  subscriptionDetails: null,
  subscriptionDetailsError: null,
  cancelSubscriptionDetails: null,
  cancelSubscriptionDetailsError: null,
  changePlanSuccess: null,
  changePlanError: null,
  changePrimaryContactSuccess: null,
  changePrimaryContactError: null,
  cancelSubscriptionSuccess: null,
  cancelSubscriptionError: null,
  verifyCancelSubscriptionSuccess: null,
  verifyCancelSubscriptionError: null,
  changePaymentMethodSuccess: null,
  changePaymentMethodError: null,
  renewSubscriptionSuccess: null,
  renewSubscriptionError: null,
  revertSubscriptionSuccess: null,
  revertSubscriptionError: null,
  verifyRenewSubscriptionSuccess: null,
  verifyRenewSubscriptionError: null,
  revertOnlySuccess: null,
  revertOnlyError: null,
  isLoading: false
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER: {
      return produce(state, draft => {
        draft.isLoading = true;
      });
    }
    case GET_CLIENT_DETAILS: {
      const clientDetails = action.payload;
      return produce(state, draft => {
        draft.clientDetails = clientDetails;
        draft.isLoading = false;
      });
    }
    case GET_CLIENT_DETAILS_ERROR: {
      const clientDetailsError = action.payload;
      return produce(state, draft => {
        draft.clientDetailsError = clientDetailsError;
        draft.isLoading = false;
      });
    }

    case REMOVE_CLIENT_DETAILS: {
      const removeClientDetails = action.payload;
      return produce(state, draft => {
        draft.removeClientDetails = removeClientDetails;
        draft.isLoading = false;
      });
    }
    case REMOVE_CLIENT_DETAILS_ERROR: {
      const removeClientDetailsError = action.payload;
      return produce(state, draft => {
        draft.removeClientDetailsError = removeClientDetailsError;
        draft.isLoading = false;
      });
    }
    case REMOVE_CLIENT_DETAILS_EMPTY: {
      return produce(state, draft => {
        draft.removeClientDetails = null;
        draft.removeClientDetailsError = null;
      });
    }

    case VERIFY_PAYMENT: {
      const verifyPaymentSuccess = action.payload;
      return produce(state, draft => {
        draft.verifyPaymentSuccess = verifyPaymentSuccess;
        draft.isLoading = false;
      });
    }
    case VERIFY_PAYMENT_ERROR: {
      const verifyPaymentError = action.payload;
      return produce(state, draft => {
        draft.verifyPaymentError = verifyPaymentError;
        draft.isLoading = false;
      });
    }
    case VERIFY_PAYMENT_EMPTY: {
      return produce(state, draft => {
        draft.verifyPaymentError = null;
        draft.verifyPaymentSuccess = null;
      });
    }

    case SUBSCRIPTION_DETAILS: {
      const subscriptionDetails = action.payload;
      return produce(state, draft => {
        draft.subscriptionDetails = subscriptionDetails;
        draft.isLoading = false;
      });
    }
    case SUBSCRIPTION_DETAILS_ERROR: {
      const subscriptionDetailsError = action.payload;
      return produce(state, draft => {
        draft.subscriptionDetailsError = subscriptionDetailsError;
        draft.isLoading = false;
      });
    }
    case SUBSCRIPTION_DETAILS_EMPTY: {
      return produce(state, draft => {
        draft.subscriptionDetailsError = null;
        draft.subscriptionDetails = null;
      });
    }

    case CANCEL_SUBSCRIPTION_DETAILS: {
      const cancelSubscriptionDetails = action.payload;
      return produce(state, draft => {
        draft.cancelSubscriptionDetails = cancelSubscriptionDetails;
        draft.isLoading = false;
      });
    }
    case CANCEL_SUBSCRIPTION_DETAILS_ERROR: {
      const cancelSubscriptionDetailsError = action.payload;
      return produce(state, draft => {
        draft.cancelSubscriptionDetailsError = cancelSubscriptionDetailsError;
        draft.isLoading = false;
      });
    }
    case CANCEL_SUBSCRIPTION_DETAILS_EMPTY: {
      return produce(state, draft => {
        draft.cancelSubscriptionDetailsError = null;
        draft.cancelSubscriptionDetails = null;
      });
    }

    case CHANGE_PLAN_SUCCESS: {
      const changePlanSuccess = action.payload;
      return produce(state, draft => {
        draft.changePlanSuccess = changePlanSuccess;
        draft.isLoading = false;
      });
    }
    case CHANGE_PLAN_ERROR: {
      const changePlanError = action.payload;
      return produce(state, draft => {
        draft.changePlanError = changePlanError;
        draft.isLoading = false;
      });
    }
    case CHANGE_PLAN_EMPTY: {
      return produce(state, draft => {
        draft.changePlanError = null;
        draft.changePlanSuccess = null;
      });
    }

    case CHANGE_PRIMARYCONTACT_SUCCESS: {
      const changePrimaryContactSuccess = action.payload;
      return produce(state, draft => {
        draft.changePrimaryContactSuccess = changePrimaryContactSuccess;
        draft.isLoading = false;
      });
    }
    case CHANGE_PRIMARYCONTACT_ERROR: {
      const changePrimaryContactError = action.payload;
      return produce(state, draft => {
        draft.changePrimaryContactError = changePrimaryContactError;
        draft.isLoading = false;
      });
    }
    case CHANGE_PRIMARYCONTACT_EMPTY: {
      return produce(state, draft => {
        draft.changePrimaryContactError = null;
        draft.changePrimaryContactSuccess = null;
      });
    }

    case CANCEL_SUBSCRIPTION_SUCCESS: {
      const cancelSubscriptionSuccess = action.payload;
      return produce(state, draft => {
        draft.cancelSubscriptionSuccess = cancelSubscriptionSuccess;
        draft.isLoading = false;
      });
    }
    case CANCEL_SUBSCRIPTION_ERROR: {
      const cancelSubscriptionError = action.payload;
      return produce(state, draft => {
        draft.cancelSubscriptionError = cancelSubscriptionError;
        draft.isLoading = false;
      });
    }
    case CANCEL_SUBSCRIPTION_EMPTY: {
      return produce(state, draft => {
        draft.cancelSubscriptionError = null;
        draft.cancelSubscriptionSuccess = null;
      });
    }

    case VERIFY_CANCEL_SUBSCRIPTION_SUCCESS: {
      const verifyCancelSubscriptionSuccess = action.payload;
      return produce(state, draft => {
        draft.verifyCancelSubscriptionSuccess = verifyCancelSubscriptionSuccess;
        draft.isLoading = false;
      });
    }
    case VERIFY_CANCEL_SUBSCRIPTION_ERROR: {
      const verifyCancelSubscriptionError = action.payload;
      return produce(state, draft => {
        draft.verifyCancelSubscriptionError = verifyCancelSubscriptionError;
        draft.isLoading = false;
      });
    }
    case VERIFY_CANCEL_SUBSCRIPTION_EMPTY: {
      return produce(state, draft => {
        draft.verifyCancelSubscriptionError = null;
        draft.verifyCancelSubscriptionSuccess = null;
      });
    }

    case RENEW_SUBSCRIPTION_SUCCESS: {
      const renewSubscriptionSuccess = action.payload;
      return produce(state, draft => {
        draft.renewSubscriptionSuccess = renewSubscriptionSuccess;
        draft.isLoading = false;
      });
    }
    case RENEW_SUBSCRIPTION_ERROR: {
      const renewSubscriptionError = action.payload;
      return produce(state, draft => {
        draft.renewSubscriptionError = renewSubscriptionError;
        draft.isLoading = false;
      });
    }
    case RENEW_SUBSCRIPTION_EMPTY: {
      return produce(state, draft => {
        draft.renewSubscriptionError = null;
        draft.renewSubscriptionSuccess = null;
      });
    }

    case REVERT_SUBSCRIPTION_SUCCESS: {
      const revertSubscriptionSuccess = action.payload;
      return produce(state, draft => {
        draft.revertSubscriptionSuccess = revertSubscriptionSuccess;
        draft.isLoading = false;
      });
    }
    case REVERT_SUBSCRIPTION_ERROR: {
      const revertSubscriptionError = action.payload;
      return produce(state, draft => {
        draft.revertSubscriptionError = revertSubscriptionError;
        draft.isLoading = false;
      });
    }
    case REVERT_SUBSCRIPTION_EMPTY: {
      return produce(state, draft => {
        draft.revertSubscriptionError = null;
        draft.revertSubscriptionSuccess = null;
      });
    }

    case VERIFY_RENEW_SUBSCRIPTION_SUCCESS: {
      const verifyRenewSubscriptionSuccess = action.payload;
      return produce(state, draft => {
        draft.verifyRenewSubscriptionSuccess = verifyRenewSubscriptionSuccess;
        draft.isLoading = false;
      });
    }
    case VERIFY_RENEW_SUBSCRIPTION_ERROR: {
      const verifyRenewSubscriptionError = action.payload;
      return produce(state, draft => {
        draft.verifyRenewSubscriptionError = verifyRenewSubscriptionError;
        draft.isLoading = false;
      });
    }
    case VERIFY_RENEW_SUBSCRIPTION_EMPTY: {
      return produce(state, draft => {
        draft.verifyRenewSubscriptionError = null;
        draft.verifyRenewSubscriptionSuccess = null;
      });
    }

    case CHANGE_PAYMENT_METHOD_SUCCESS: {
      const changePaymentMethodSuccess = action.payload;
      return produce(state, draft => {
        draft.changePaymentMethodSuccess = changePaymentMethodSuccess;
        draft.isLoading = false;
      });
    }
    case CHANGE_PAYMENT_METHOD_ERROR: {
      const changePaymentMethodError = action.payload;
      return produce(state, draft => {
        draft.changePaymentMethodError = changePaymentMethodError;
        draft.isLoading = false;
      });
    }
    case CHANGE_PAYMENT_METHOD_EMPTY: {
      return produce(state, draft => {
        draft.changePaymentMethodError = null;
        draft.changePaymentMethodSuccess = null;
      });
    }

    case REVERT_ONLY_SUCCESS: {
      const revertOnlySuccess = action.payload;
      return produce(state, draft => {
        draft.revertOnlySuccess = revertOnlySuccess;
        draft.isLoading = false;
      });
    }
    case REVERT_ONLY_ERROR: {
      const revertOnlyError = action.payload;
      return produce(state, draft => {
        draft.revertOnlyError = revertOnlyError;
        draft.isLoading = false;
      });
    }
    case REVERT_ONLY_EMPTY: {
      return produce(state, draft => {
        draft.revertOnlyError = null;
        draft.revertOnlySuccess = null;
      });
    }

    default: {
      return state;
    }
  }
};

export default subscriptionReducer;
